export const whiteList404 = [
  new RegExp('/accounts/\\d+/geofence/nearest'),
  // The Returnable Containers routes answer 404 while the account is not entitled to the
  // feature. The UI only calls them when the flag is on, but the flag can be
  // turned off mid-session and the SPA can reach an engine that does not have the routes
  // yet — neither should replace the page the user is on with the 404 view.
  new RegExp('/accounts/\\d+/container-types'),
  new RegExp('/accounts/\\d+/find-containers'),
];

export function isWhiteListedURL(url) {
  return whiteList404.some((p) => p.test(url));
}
